import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { createTheme } from '@material-ui/core';
import { ThemeProvider, StylesProvider } from '@material-ui/styles';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, microsoftEnabled } from './authConfig';


const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#ff4400',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // error: will use the default color
  },
});

function renderApp(app) {
  ReactDOM.render(
    <StylesProvider injectFirst>
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <Router>
              {app}
            </Router>
          </Provider>
        </ThemeProvider>
      </React.StrictMode>
    </StylesProvider>,
    document.getElementById('root')
  );
}

if (microsoftEnabled) {
  // @azure/msal-browser v2 is ready synchronously - no initialize() needed
  // (v2 is pinned because this project's react-scripts 4 / webpack 4 cannot
  // resolve the package "exports" field used by msal-common 14.x / msal v3).
  const msalInstance = new PublicClientApplication(msalConfig);
  renderApp(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
} else {
  // Google-only path: render exactly as before, no MSAL involved.
  renderApp(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
